import { EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { UserComplete } from "../../../models/account/user-complete.model";

export const adminUserAdapter: EntityAdapter<UserComplete> = createEntityAdapter<UserComplete>({
    selectId: state => state.id!,
    sortComparer: (a,b) => a.surname.localeCompare(b.surname) && a.firstname.localeCompare(b.firstname)
});